import styled, { keyframes } from 'styled-components'

const ListAnimation = keyframes`
  0% {
    max-height: 0;
  }
  
  100% {
    max-height: 100%;
  }
`

const ListItemAnimation = keyframes`
  0% {
    padding: 0 20px;
    color: #fff;
  }
`

export const DropdownItem = styled.li`
  min-width: 198px;
  border-bottom: 1px solid #e2e2e2;
  background-color: #fff;
  position: relative;

  & button {
    padding: 16px 20px;
    width: 100%;
    text-align: left;
    //animation: ${ListItemAnimation} 500ms ease-in-out 0s;
  }
`

export const DropdownList = styled.ul`
  position: absolute;
  right: 0;
  list-style: none;
  margin-top: 0.5rem;
  border-radius: 4px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
  //animation: ${ListAnimation} 0.5s ease-in-out 0s;
  z-index: 1;

  & li:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  & li:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`
